import { isXSell } from "@tvg/sh-utils/mobileUtils";
import { getXsellKeys } from "../../utils";
import { ENV_KEYS } from "../../constants";

export const EXPERIMENT_KEY = "uw-4875";

export const DEPLOYMENT_KEY = isXSell() ? getXsellKeys() : ENV_KEYS.fdr_fe.web;

export const DEFAULT_PAYLOAD = false;
